// 平台核心价值
import React from 'react'
import styles from './ValueSection.module.scss'
import cardLogo1 from '@assets/img/cardLogo1.png'
import cardLogo2 from '@assets/img/cardLogo2.png'
import cardLogo3 from '@assets/img/cardLogo3.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'

const ValueSection: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])
  return (
    <section className={styles.section}>
      <div className={styles.contentWrapper}>
        <div className={styles.sectionHeader}>
          {t('ourAdvantages', "我们的优势")}
        </div>
        <div className={styles.valueGrid}>
          <div className={styles.valueCard}>
            <div className={styles.cardLogo}>
              <img src={cardLogo1} alt="cardLogo1"  />
            </div>
            <div className={styles.cardTitle}>{t('marketSize', "市场规模")}</div>
            <div className={styles.cardDesc}>{t('marketSizeDescription', "美团/大众点评到店餐饮、休闲娱乐业务，年度交易用户7.7亿，年活跃商户1450万")}</div>
          </div>
          <div className={styles.valueCard}>
            <div className={styles.cardLogo}>
              <img src={cardLogo2} alt="cardLogo2" />
            </div>
              <div className={styles.cardTitle}>{t('marketingCapabilities', "营销赋能")}</div>
            <div className={styles.cardDesc}>{t('marketingCapabilitiesDescription', "提供品牌广告、CPC效果广告、CPS团购交易等多种营销工具，根据商户需求定制化搭配出售")}</div>
          </div>
          <div className={styles.valueCard}>
            <div className={styles.cardLogo}>
              <img src={cardLogo3} alt="cardLogo3" />
            </div>
            <div className={styles.cardTitle}>{t('toolCapabilities', "工具赋能")}</div>
            <div className={styles.cardDesc}>{t('toolCapabilitiesDescription', "提供配套CRM管理系统、商家线上运营系统，保障销售作业与门店运营便捷、高效")}</div>
          </div>
        </div>
      </div>
    </section>
  )
}

const ValueSectionWithTranslator = withTranslator(ValueSection)
export default ValueSectionWithTranslator

